import React from 'react';

import { AuthSignupConsumerContext } from 'src/providers/AuthSignupConsumerProvider';

export const useAuthSignupConsumer = () => {
  return React.use(AuthSignupConsumerContext);
};
